









  import Vue from 'vue';

  export default Vue.extend({
    name: 'SectionFormulaire',
    props: {
      encadre: {
        type: Boolean,
        default: true,
      },
      elevation: {
        type: Number,
        default: 1,
      },
      titre: {
        type: String,
        required: false,
        default: undefined,
      },
    },
  });
